var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "studentForm" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.saveStudentEntityForm.apply(null, arguments)
                },
                reset: function ($event) {
                  $event.preventDefault()
                  return _vm.clearForm.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/3 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("student.document"),
                          "label-for": "document",
                        },
                      },
                      [
                        _c("validation-provider", {
                          staticClass: "flex-grow",
                          attrs: {
                            name: _vm.$t("student.document"),
                            rules: "required",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: ["###.###.###-##"],
                                        expression: "['###.###.###-##']",
                                      },
                                    ],
                                    staticClass: "required",
                                    attrs: {
                                      id: "document",
                                      state: errors.length > 0 ? false : null,
                                      name: "document",
                                    },
                                    model: {
                                      value: _vm.studentEntity.document,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.studentEntity,
                                          "document",
                                          $$v
                                        )
                                      },
                                      expression: "studentEntity.document",
                                    },
                                  }),
                                  _c("small", { staticClass: "text-danger" }, [
                                    _vm._v(_vm._s(errors[0])),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-2/3 w-full" },
                  [
                    _c("validation-provider", {
                      staticClass: "flex-grow",
                      attrs: {
                        name: _vm.$t("student.name"),
                        rules: "required",
                        slim: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (validationContext) {
                            return [
                              _c(
                                "b-form-group",
                                {
                                  class: [
                                    _vm.inline
                                      ? "flex-col items-start pb-1 inline-input-group"
                                      : "",
                                  ],
                                  attrs: {
                                    id: "input-group-1",
                                    label: _vm.$t("student.name"),
                                    "label-for": "name",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "required pr-0 w-full",
                                    attrs: {
                                      id: "name",
                                      type: "text",
                                      state:
                                        _vm.getValidationState(
                                          validationContext
                                        ),
                                    },
                                    model: {
                                      value: _vm.studentEntity.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.studentEntity, "name", $$v)
                                      },
                                      expression: "studentEntity.name",
                                    },
                                  }),
                                  _c(
                                    "b-form-invalid-feedback",
                                    { class: [{ absolute: _vm.inline }] },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(validationContext.errors[0]) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row mt-1" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c("validation-provider", {
                      staticClass: "flex-grow",
                      attrs: {
                        name: _vm.$t("student.email"),
                        rules: "email|required",
                        slim: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (validationContext) {
                            return [
                              _c(
                                "b-form-group",
                                {
                                  class: [
                                    _vm.inline
                                      ? "flex-col items-start pb-1 inline-input-group"
                                      : "",
                                  ],
                                  attrs: {
                                    id: "input-group-2",
                                    label: _vm.$t("student.email"),
                                    "label-for": "email",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "required pr-0 w-full",
                                    attrs: {
                                      id: "email",
                                      type: "email",
                                      state:
                                        _vm.getValidationState(
                                          validationContext
                                        ),
                                      disabled: _vm.isEdit(),
                                    },
                                    model: {
                                      value: _vm.studentEntity.email,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.studentEntity,
                                          "email",
                                          $$v
                                        )
                                      },
                                      expression: "studentEntity.email",
                                    },
                                  }),
                                  _c(
                                    "b-form-invalid-feedback",
                                    { class: [{ absolute: _vm.inline }] },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(validationContext.errors[0]) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/4 w-full" },
                  [
                    _c("validation-provider", {
                      staticClass: "flex-grow",
                      attrs: {
                        name: _vm.$t("student.birthdate"),
                        rules: "required|min_age",
                        slim: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (validationContext) {
                            return [
                              _c(
                                "b-form-group",
                                {
                                  class: [
                                    _vm.inline
                                      ? "flex-col items-start pb-1 inline-input-group"
                                      : "",
                                  ],
                                  attrs: {
                                    id: "input-group-3",
                                    label: _vm.$t("student.birthdate"),
                                    "label-for": "birthdate",
                                  },
                                },
                                [
                                  _c("datepicker", {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: ["##/##/####"],
                                        expression: "['##/##/####']",
                                      },
                                    ],
                                    staticClass: "required",
                                    attrs: {
                                      id: "birthdate",
                                      format: _vm.format,
                                      language: _vm.ptBR,
                                      typeable: "true",
                                    },
                                    model: {
                                      value: _vm.studentEntity.birthdate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.studentEntity,
                                          "birthdate",
                                          $$v
                                        )
                                      },
                                      expression: "studentEntity.birthdate",
                                    },
                                  }),
                                  _c(
                                    "b-form-invalid-feedback",
                                    { class: [{ absolute: _vm.inline }] },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(validationContext.errors[0]) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row mt-1" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "description",
                          label: _vm.$t("student.description"),
                          "label-for": "description",
                        },
                      },
                      [
                        _c("complex-editor", {
                          attrs: { editor_data: _vm.studentEntity.description },
                          on: {
                            "update:editor_data": function ($event) {
                              return _vm.$set(
                                _vm.studentEntity,
                                "description",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "vx-row mt-2 mb-2" }, [
                _c(
                  "div",
                  { staticClass: "vx-col w-full flex gap-2 justify-end" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "ripple",
                            rawName: "v-ripple.400",
                            value: "rgba(255, 255, 255, 0.15)",
                            expression: "'rgba(255, 255, 255, 0.15)'",
                            modifiers: { 400: true },
                          },
                        ],
                        staticClass: "float-right",
                        attrs: {
                          variant: "primary",
                          disabled: !_vm.validateForm,
                          type: "submit",
                        },
                      },
                      [_vm._v(" Salvar ")]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "float-right",
                        attrs: { type: "reset", variant: "outline-secondary" },
                      },
                      [
                        _vm._t("reset-button-text", function () {
                          return [_vm._v("Limpar")]
                        }),
                      ],
                      2
                    ),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "ripple",
                            rawName: "v-ripple.400",
                            value: "rgba(255, 255, 255, 0.15)",
                            expression: "'rgba(255, 255, 255, 0.15)'",
                            modifiers: { 400: true },
                          },
                        ],
                        staticClass: "float-right mr-2",
                        attrs: { variant: "outline-secondary" },
                        on: { click: _vm.goBack },
                      },
                      [_vm._v(" Voltar ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }